var _excluded = ["title", "subtitle", "phone", "image", "contactButtons", "infoBoxes"],
  _excluded2 = ["isVisibleOnSmallOnly"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import TextAtm from "../../atoms/TextAtm";
import DescriptionItemLinkMol from "../../molecules/DescriptionItemLinkMol";
import IconButtonMol from "../../molecules/IconButtonMol";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import ContainerOrg from "../../organisms/ContainerOrg";
import ContentWithImageOrg from "../../organisms/ContentWithImageOrg";
import PushOrg from "../../organisms/PushOrg";
import SectionOrg from "../../organisms/SectionOrg";
import WaffleOrg from "../../organisms/WaffleOrg";
import WrapOrg from "../../organisms/WrapOrg";
import Picture from "../../quarks/Picture";
function HelpSectionTemplate(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    phone = _ref.phone,
    image = _ref.image,
    contactButtons = _ref.contactButtons,
    infoBoxes = _ref.infoBoxes,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var contactButtonsJsx = contactButtons.map(function (contactButton) {
    var isVisibleOnSmallOnly = contactButton.isVisibleOnSmallOnly,
      contactButtonProps = _objectWithoutProperties(contactButton, _excluded2);
    var button;
    if (!isVisibleOnSmallOnly) {
      button = /*#__PURE__*/React.createElement(IconButtonMol, _extends({}, contactButtonProps, {
        key: contactButton.text
      }));
    }
    if (isVisibleOnSmallOnly) {
      button = /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
        from: "small",
        to: "medium",
        key: contactButton.text
      }, /*#__PURE__*/React.createElement(IconButtonMol, contactButtonProps));
    }
    return button;
  });
  var contactContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "huge",
    pushSpace: 1
  }, title), /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: {
      small: 8,
      medium: 4,
      large: 4
    }
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "xlarge"
  }, subtitle)), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 4
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "big3",
    pushSpace: 1
  }, phone.title), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "huge"
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "xlarge"
  }, phone.prefix), " ", phone.number)), /*#__PURE__*/React.createElement(WrapOrg, {
    gutterSpace: 4
  }, contactButtonsJsx)), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(WaffleOrg, {
    columnWidth: "tiny"
  }, contactButtonsJsx)));
  return /*#__PURE__*/React.createElement("div", restProps, /*#__PURE__*/React.createElement(SectionOrg, {
    hasSeparator: !!infoBoxes
  }, /*#__PURE__*/React.createElement(ContainerOrg, null, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, /*#__PURE__*/React.createElement(ContentWithImageOrg, {
    content: contactContent,
    image: /*#__PURE__*/React.createElement(Picture, {
      srcData: image
    }),
    gutter: "small",
    hasImageStickyToBottom: true
  })), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "large"
  }, contactContent))), infoBoxes ? /*#__PURE__*/React.createElement(SectionOrg, {
    spacing: "small"
  }, /*#__PURE__*/React.createElement(ContainerOrg, null, /*#__PURE__*/React.createElement(WaffleOrg, {
    columnWidth: "small"
  }, infoBoxes.map(function (infoBox) {
    return /*#__PURE__*/React.createElement(DescriptionItemLinkMol, _extends({}, infoBox, {
      key: infoBox.title
    }));
  })))) : null);
}
export default HelpSectionTemplate;